import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const DRCongoFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14518'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14518)'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='#158AFF'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M23.1133 3.64319L-1.49547 15.9312L-4.0897 10.9416L20.519 -1.34645L23.1133 3.64319Z'
					fill='#FDD216'
				/>
				<rect
					width='27.5061'
					height='3.74916'
					transform='matrix(-0.894665 0.446738 -0.4613 -0.887244 22.9434 2.6416)'
					fill='#CE1120'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M3.33408 4.17668L1.93459 5.15439L2.45095 3.54789L1.06966 2.54564L2.78828 2.53048L3.33408 0.93335L3.87988 2.53048L5.5985 2.54564L4.2172 3.54789L4.73357 5.15439L3.33408 4.17668Z'
					fill='#FDD216'
				/>
			</g>
		</svg>
	);
};

export default DRCongoFlagIcon;
